var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignageProof(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 426.703 426.703",
    height: 512,
    viewBox: "0 0 426.703 426.703",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m352.811 74.48h19.222c5.662 0 10.251 4.59 10.251 10.251v32.872h-39.725v-32.887c.009-5.655 4.596-10.236 10.252-10.236z",
    fill: "#575b6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.575 61.242h-118.447c-5.685-.001-10.906 3.135-13.576 8.154l-25.654 48.207h196.908l-25.659-48.228c-2.676-5.008-7.894-8.135-13.572-8.133z",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.628 102.778h375.447c14.154 0 25.628 11.474 25.628 25.628v211.426c0 14.154-11.474 25.628-25.628 25.628h-375.447c-14.154.001-25.628-11.473-25.628-25.627v-211.427c0-14.154 11.474-25.628 25.628-25.628z",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 164.499h426.703v139.246h-426.703z",
    fill: "#575b6d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.352,
    cy: 234.119,
    fill: "#686d82",
    r: 104.542
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.26 234.125c.085 43.684-35.259 79.165-78.943 79.249-43.684.085-79.165-35.259-79.249-78.943-.085-43.684 35.259-79.165 78.943-79.249 16.072-.031 31.771 4.834 45.009 13.949 21.406 14.716 34.208 39.017 34.24 64.994z",
    fill: "#419be9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.81 213.674c.063 43.531-35.175 78.871-78.706 78.934-16.026.023-31.679-4.84-44.871-13.94-24.655-35.901-15.539-84.991 20.362-109.646 26.947-18.506 62.519-18.468 89.426.098 8.99 13.118 13.797 28.651 13.789 44.554z",
    fill: "#69b0ee"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.126,
    cy: 192.797,
    fill: "#eeefee",
    r: 15.804
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.045,
    cy: 223.899,
    fill: "#eeefee",
    r: 7.046
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.576,
    cy: 137.029,
    fill: "#ef5261",
    r: 13.415
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.022 242.242c.029 22.111-6.988 43.656-20.034 61.508h-14.674c35.455-39.647 35.455-99.604 0-139.251 22.117 19.786 34.744 48.067 34.708 77.743z",
    fill: "#464956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.977 303.75c-33.942 46.671-99.291 56.991-145.963 23.049-6.035-4.389-11.583-9.412-16.549-14.984 42.841 38.608 108.869 35.177 147.477-7.664.12-.134.24-.268.36-.402h14.675z",
    fill: "#bbbbcd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignageProof);
export default __webpack_public_path__ + "static/media/signage-proof.4ae437c1e93ecc22cf9a75d7eda6080e.svg";
export { ForwardRef as ReactComponent };